<template>
  <el-dropdown trigger="click">
    <span class="el-dropdown-link">
      <slot></slot>
    </span>
    <el-dropdown-menu slot="dropdown" class="c-dropdown">
      <el-dropdown-item
        :class="{ 'select-item': value === i.type }"
        @click.native="command(i)"
        :key="i.type"
        v-for="i in listView"
      >
        {{ i.name }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { aggregatorMap } from '../../utils/enum.data'

export default {
  name: 'cDropdown',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      listView: this.list,
    }
  },
  created() {
    for (let i in aggregatorMap) {
      this.listView.push({ name: aggregatorMap[i], type: i })
    }
  },
  methods: {
    command(item) {
      this.$emit('input', item.type)
    },
  },
}
</script>

<style scoped lang="less">
.c-dropdown {
  background-color: #081226;
  border-color: transparent;

  li {
    color: hsla(0, 0%, 100%, 0.65);
  }

  .select-item {
    background-color: #293451;
    color: var(--bi-jz-font-color);
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    .select-item;
  }
}
</style>
